import { spacing } from 'main/ui'
import { dateCardLimit } from './util'

export const dateCardWidth = 75
export const dateCardMargin = spacing.majorScale(1)
export const dateCardContainerMaxWidth =
  dateCardWidth * dateCardLimit + dateCardMargin * (dateCardLimit - 1)
